import { createNullableProvideInject } from '@collector/shared-ui'

import { LastIncidentsConfig } from '../configuration'

export const [provideLastIncidentsConfig, injectLastIncidentsConfig] =
  createNullableProvideInject<LastIncidentsConfig>('lastIncidentsConfig')
